import React, { useState } from 'react';

import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const ApplicantFilters = ({ filters, onFiltersChange, resultCount, positions = [] }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  // Build positions list with "All Positions" option at the top
  const positionOptions = [
    { value: '', label: 'All Positions' },
    ...positions
  ];

  const statuses = [
    { value: '', label: 'All Statuses' },
    { value: 'applied', label: 'Applied' },
    { value: 'screening', label: 'Screening' },
    { value: 'interview', label: 'Interview Scheduled' },
    { value: 'offer', label: 'Offer Extended' },
    { value: 'hired', label: 'Hired' },
    { value: 'rejected', label: 'Rejected' }
  ];

  const hrAssignees = [
    { value: '', label: 'All HR Personnel' },
    { value: 'priya-sharma', label: 'Priya Sharma' },
    { value: 'rajesh-kumar', label: 'Rajesh Kumar' },
    { value: 'anita-singh', label: 'Anita Singh' },
    { value: 'vikram-patel', label: 'Vikram Patel' }
  ];

  const handleFilterChange = (key, value) => {
    onFiltersChange({
      ...filters,
      [key]: value
    });
  };

  const clearAllFilters = () => {
    onFiltersChange({
      search: '',
      position: '',
      status: '',
      hrAssignee: '',
      is_duplicate: '',
      dateFrom: '',
      dateTo: ''
    });
  };

  const hasActiveFilters = Object.values(filters).some(value => value !== '');

  return (
    <div className="bg-card rounded-lg border border-border p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-4">
          <div>
            <h3 className="text-lg font-semibold text-foreground">Filter Applicants</h3>
            <p className="text-sm text-muted-foreground">
              {resultCount} applicants found
            </p>
          </div>
          {hasActiveFilters && (
            <Button
              variant="outline"
              size="sm"
              onClick={clearAllFilters}
              iconName="X"
              iconPosition="left"
            >
              Clear All
            </Button>
          )}
        </div>
        
        <Button
          variant="ghost"
          size="sm"
          onClick={() => setIsExpanded(!isExpanded)}
          iconName={isExpanded ? "ChevronUp" : "ChevronDown"}
          iconPosition="right"
        >
          {isExpanded ? 'Less Filters' : 'More Filters'}
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
        <Input
          type="search"
          placeholder="Search by name, email..."
          value={filters.search}
          onChange={(e) => handleFilterChange('search', e.target.value)}
          className="w-full"
        />

        <select
          value={filters.position}
          onChange={(e) => handleFilterChange('position', e.target.value)}
          className="w-full px-3 py-2 bg-background border border-input rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-ring"
        >
          {positionOptions.map(position => (
            <option key={position.value} value={position.value}>
              {position.label}
            </option>
          ))}
        </select>

        <select
          value={filters.status}
          onChange={(e) => handleFilterChange('status', e.target.value)}
          className="w-full px-3 py-2 bg-background border border-input rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-ring"
        >
          {statuses.map(status => (
            <option key={status.value} value={status.value}>
              {status.label}
            </option>
          ))}
        </select>

        <select
          value={filters.hrAssignee}
          onChange={(e) => handleFilterChange('hrAssignee', e.target.value)}
          className="w-full px-3 py-2 bg-background border border-input rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-ring"
        >
          {hrAssignees.map(hr => (
            <option key={hr.value} value={hr.value}>
              {hr.label}
            </option>
          ))}
        </select>
      </div>

      {isExpanded && (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 pt-4 border-t border-border">
          <div>
            <label className="block text-xs font-medium text-muted-foreground mb-1">Duplicate Status</label>
            <select
              value={filters.is_duplicate || ''}
              onChange={(e) => handleFilterChange('is_duplicate', e.target.value)}
              className="w-full px-3 py-2 bg-background border border-input rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-ring"
            >
              <option value="">All (Unique & Duplicates)</option>
              <option value="0">Unique Profiles Only</option>
              <option value="1">Duplicate Filings Only</option>
            </select>
          </div>

          <Input
            type="date"
            label="Application Date From"
            value={filters.dateFrom}
            onChange={(e) => handleFilterChange('dateFrom', e.target.value)}
          />

          <Input
            type="date"
            label="Application Date To"
            value={filters.dateTo}
            onChange={(e) => handleFilterChange('dateTo', e.target.value)}
          />

          <div className="flex items-end">
            <Button
              variant="outline"
              iconName="Download"
              iconPosition="left"
              className="w-full"
            >
              Export Results
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ApplicantFilters;